import { render, staticRenderFns } from "./ProjectCollaborators.vue?vue&type=template&id=81e82194&scoped=true"
import script from "./ProjectCollaborators.vue?vue&type=script&lang=js"
export * from "./ProjectCollaborators.vue?vue&type=script&lang=js"
import style0 from "./ProjectCollaborators.vue?vue&type=style&index=0&id=81e82194&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e82194",
  null
  
)

export default component.exports